export const dataMartApi = {
  rootUrl: window.APP_CONFIG.DATA_MART_SEARCH_ADDRESS,
  graphQlUrl: window.APP_CONFIG.DATA_MART_GRAPHQL_ADDRESS,
  crudUrl: window.APP_CONFIG.DATA_MART_ADDRESS,
};
